/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Home_KeywordsInputs */

const en_seo_home_keywords = /** @type {(inputs: Seo_Home_KeywordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`best AI tools, AI tools directory, AI tools 2026, ChatGPT alternatives, AI image generator, AI video generator, AI coding assistant, best AI for writing, AI tool reviews`)
};

const zh_seo_home_keywords = /** @type {(inputs: Seo_Home_KeywordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI工具导航, AI工具大全, 好用的AI工具, ChatGPT替代, AI绘画工具, AI视频生成, AI编程助手, 免费AI工具, 2026 AI工具`)
};

/**
* | output |
* | --- |
* | "best AI tools, AI tools directory, AI tools 2026, ChatGPT alternatives, AI image generator, AI video generator, AI coding assistant, best AI for writing, AI ..." |
*
* @param {Seo_Home_KeywordsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_home_keywords = /** @type {((inputs?: Seo_Home_KeywordsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Home_KeywordsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_home_keywords(inputs)
	return zh_seo_home_keywords(inputs)
});
export { seo_home_keywords as "seo.home.keywords" }